export const queryKeys = {
  base: () => ['alerts'],
  active: () => [...queryKeys.base(), 'active'] as const,
  rules: () => [...queryKeys.base(), 'rules'] as const,
  rule: (id: number) => [...queryKeys.rules(), id] as const,
  settings: () => [...queryKeys.base(), 'settings'] as const,
  silenced: () => [...queryKeys.base(), 'silenced'] as const,
  attachments: (id: number) =>
    [...queryKeys.rules(), 'attachments', id] as const,
  environments: (id: number) =>
    [...queryKeys.rule(id), 'environments'] as const,
};
